import * as React from 'react';
import classnames from 'classnames';
import kebabCase from 'lodash/kebabCase';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import ContentCardStatsInstagramPost from './instagram/post/ContentCardStatsInstagramPost';
import ContentCardStatsInstagramReel from './reel/ContentCardStatsInstagramReel';
import ContentCardStatsInstagramStory from './instagram/story/ContentCardStatsInstagramStory';
import ContentCardStatsTiktokVideo from './tiktok/ContentCardStatsTiktokVideo';
import ContentCardStatsYoutubeVideo from './youtube/ContentCardStatsYoutubeVideo';

import {
  DELIVERABLE_TYPE_INSTAGRAM_POST as IG_POST_TYPE,
  DELIVERABLE_TYPE_INSTAGRAM_REEL as IG_REEL_TYPE,
  DELIVERABLE_TYPE_INSTAGRAM_STORY as IG_STORY_TYPE,
  DELIVERABLE_TYPE_TIKTOK_VIDEO as TT_VIDEO_TYPE,
  DELIVERABLE_TYPE_YOUTUBE_VIDEO as YT_VIDEO_TYPE
} from 'utils/deliverables';

import './content-card-stats.scss';

import type {
  ContentCardItem
} from 'components/cards/content-card/types';
import type {
  ReportingMetaInfoIGStorySnippetType
} from 'modules/reporting/types';

type Props = {
  item: ContentCardItem,
  toggleStats: boolean,
  igStorySnippetType?: ReportingMetaInfoIGStorySnippetType,
  hideIcon?: boolean,
  position?: 'static' | 'absolute',
  onToggleStats?: () => void
};

const ContentCardStats = ({
  item,
  toggleStats,
  igStorySnippetType,
  hideIcon,
  position,
  onToggleStats
}: Props
): JSX.Element => {
  const containerClasses = classnames('content-card-stats', {
    [`content-card-stats--is-${kebabCase(item.type)}`]: Boolean(item.type),
    'content-card-stats--is-visible': toggleStats,
    [`content-card-stats--${position}-yes`]: Boolean(position)
  });

  return (
    <div className={containerClasses}>
      {
        !hideIcon && (
          <div
            className="content-card-stats__icon"
            onClick={onToggleStats}
          >
            <SVGDynamicIcon
              name="cross-custom-fg"
              width={12}
              height={12}
              customColor="grey"
              clickable
            />
          </div>
        )
      }
      {
        item.type === IG_POST_TYPE && (
          <ContentCardStatsInstagramPost item={item} />
        )
      }
      {
        item.type === IG_STORY_TYPE && (
          <ContentCardStatsInstagramStory
            item={item}
            igStorySnippetType={igStorySnippetType}
          />
        )
      }
      {
        item.type === IG_REEL_TYPE && (
          <ContentCardStatsInstagramReel
            item={item}
          />
        )
      }
      {
        item.type === TT_VIDEO_TYPE && (
          <ContentCardStatsTiktokVideo item={item} />
        )
      }
      {
        item.type === YT_VIDEO_TYPE && (
          <ContentCardStatsYoutubeVideo item={item} />
        )
      }
    </div>
  );
};

export default ContentCardStats;
